import type { PopStoreExtendedSubscriptionLevel } from '@ps/models/lib/creator-subscription';

import type { ChannelSubscriptionLevel } from '../../types/ChannelSubscriptionLevel';

/**
 * FOLLOWER < SUBSCRIBER < FAN < VIP. Both `ChannelSubscriptionLevel` (the API
 * enum) and `PopStoreExtendedSubscriptionLevel` (the model enum) carry these
 * identical string values, so we rank by string to compare across the two.
 */
const kOrderedLevels: string[] = ['follower', 'subscriber', 'fan', 'vip'];

/**
 * Whether a viewer's standing meets a channel's `minimumSubscriptionLevel` —
 * the web port of PopshopRN's `compareExtendedSubscriptionLevel(...) >= 0`
 * subscription gate. This is a PURE level comparison independent of visibility:
 * a **public** channel is readable by anyone, but *joining* (and posting) still
 * requires the level, so the join flow gates on this even for public channels.
 * The caller resolves the viewer's level (synthesizing FOLLOWER from a plain
 * follow) before calling.
 */
export function hasChannelSubscriptionAccess(
  viewerLevel: PopStoreExtendedSubscriptionLevel | undefined,
  minimumSubscriptionLevel: ChannelSubscriptionLevel,
): boolean {
  if (viewerLevel == null) return false;
  return (
    kOrderedLevels.indexOf(viewerLevel) >=
    kOrderedLevels.indexOf(minimumSubscriptionLevel)
  );
}
